module.exports = __webpack_public_path__ + "img/icon_4_3.8da7b411.png";